import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Container from '../components/ui/Container';
import Button from '../components/ui/Button';

const NotFoundContainer = styled(Container)`
  text-align: center;
  padding: 4.8rem;
`;

const Title = styled.h1`
  font-size: 6.4rem;
  margin-bottom: 1.6rem;
  color: var(--color-accent);
`;

const Subtitle = styled.h2`
  font-size: 2.4rem;
  margin-bottom: 3.2rem;
  color: var(--color-light);
`;

const Text = styled.p`
  font-size: 1.8rem;
  margin-bottom: 3.2rem;
`;

function NotFoundPage() {
  return (
    <NotFoundContainer>
      <Title>404</Title>
      <Subtitle>Page Not Found</Subtitle>
      <Text>The page you're looking for doesn't exist or has been moved.</Text>
      <Link to="/">
        <Button $primary>Go to Home</Button>
      </Link>
    </NotFoundContainer>
  );
}

export default NotFoundPage;
